import { SxProps, Theme } from '@mui/material';

export const autoCompleteSx: SxProps<Theme> = ({ backrs }) => ({
  mb: {
    xs: backrs.spacing['spacing-md'],
    md: backrs.spacing['spacing-xl'],
  },
  height: 'unset',

  '& .MuiAutocomplete-endAdornment': {
    top: '20px',
  },

  '& .MuiAutocomplete-tag': {
    margin: `${backrs.spacing['spacing-none']}`,
  },
  '& .MuiAutocomplete-popupIndicator': {
    transition: 'transform 0.3s ease',
  },

  '& .MuiAutocomplete-root': {},
  '& .MuiAutocomplete-inputRoot': {
    height: 'unset',
    border: `1px solid ${backrs.colors['Colors/Border/border-primary']}`,
    paddingY: `${backrs.spacing['spacing-none']} !important`,
    paddingX: { xs: `${backrs.spacing['spacing-sm']} !important` },

    gap: backrs.spacing['spacing-xs'],
    minHeight: '40px',
  },
});

export const searchIconSx: SxProps<Theme> = ({ backrs }) => ({
  paddingX: backrs.spacing['spacing-xs'],
  mt: backrs.spacing['spacing-xs'],
});

export const tagContainerSx: SxProps<Theme> = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 1,
  paddingY: 0.5,
};

export const underneathTagContainerSx: SxProps<Theme> = ({ backrs }) => ({
  ...tagContainerSx,
  mb: backrs.spacing['spacing-lg'],
});

export const selectTextFieldStyle =
  (isLastItem: boolean, divider: boolean): SxProps<Theme> =>
  ({ backrs }) => ({
    mb: {
      xs: backrs.spacing['spacing-md'],
      sm: backrs.spacing[isLastItem ? 'spacing-md' : 'spacing-2xl'],
    },
    ...(divider && {
      mb: backrs.spacing['spacing-none'],
    }),
    width: '100%',
    '& .MuiAutocomplete-inputRoot': {
      paddingY: `${backrs.spacing['spacing-xs']}`,
      paddingX: `${backrs.spacing['spacing-md']}`,
      gap: `${backrs.spacing['spacing-none']}`,
      minHeight: '44px',
      alignItems: 'center',
    },
    '& .MuiInputBase-root': {
      minHeight: '44px',
    },
  });

export const menuItemSx: SxProps<Theme> = ({ backrs }) => ({
  transition: 'all 0.3s ease-in-out',
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
  '&.MuiMenuItem-root': {
    '&:hover': {
      backgroundColor: `${backrs.colors['Colors/Background/bg-active']} !important`,
    },
  },
  '&.Mui-focusVisible': {
    backgroundColor: `${backrs.colors['Colors/Background/bg-active']} !important`,
  },
  '& .MuiCheckbox-root': {
    pointerEvents: 'none',
  },

  '&.Mui-selected': {
    backgroundColor: `${backrs.colors['Colors/Background/bg-active']} !important`,
  },
  '&.Mui-selected:hover': {
    backgroundColor: `${backrs.colors['Colors/Background/bg-active']} !important`,
  },
  '&.Mui-selected.Mui-focusVisible': {
    backgroundColor: `${backrs.colors['Colors/Background/bg-active']} !important`,
  },

  '&[aria-selected="true"]': {
    backgroundColor: `${backrs.colors['Colors/Background/bg-active']} !important`,
  },
  '&.Mui-focused': {
    backgroundColor: `${backrs.colors['Colors/Background/bg-active']} !important`,
  },
});
